import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-md bg-brand-beige-60/70",
        "before:absolute before:inset-0 before:-translate-x-full",
        "before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent",
        "before:animate-[brand-shimmer_1.6s_ease-in-out_infinite]",
        className
      )}
      {...props} />
  );
}

export { Skeleton }
